import React from "react";
import { observer } from "mobx-react";
import styled from "styled-components";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import { IMediaQueries } from "../../../services/media-query/media-queries.interface";

const MQBox = styled.div<{mq: keyof IMediaQueries}>`
    display: inline-block;
    width: 200px;
    margin: 4px 8px 4px 0;
    padding: 5px 0;
    text-align: center;
    font-size: 1.6rem;
    color: ${({theme}) => theme.colors.text};
    border: 2px solid #777;
    border-radius: 4px;
    background-color: black;
    text-decoration: line-through;
    background-color: red;

    @media ${({theme, mq}) => theme.mediaQuery[mq]} {
        text-decoration: none;
        background-color: green;

        &:hover {
            background-color: darkgreen;
        }
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        width: 45%;
    }
`;

export const MediaQueryShowcase = observer(class MediaQueryShowcase extends OrbitComponent {

    render() {
        return <>
            <div>
                <MQBox mq="pointer">
                    pointer
                </MQBox>
                <MQBox mq="pointerFine">
                    pointer: fine
                </MQBox>
                <MQBox mq="pointerCoarse">
                    pointer: coarse
                </MQBox>
                <MQBox mq="pointerNone">
                    pointer: none
                </MQBox>
            </div>
            <div>
                <MQBox mq="anyPointer">
                    any-pointer
                </MQBox>
                <MQBox mq="anyPointerFine">
                    any-pointer: fine
                </MQBox>
                <MQBox mq="anyPointerCoarse">
                    any-pointer: coarse
                </MQBox>
                <MQBox mq="anyPointerNone">
                    any-pointer: none
                </MQBox>
            </div>
            <div>
                <MQBox mq="hover">
                    hover: hover
                </MQBox>
                <MQBox mq="hoverNone">
                    hover: none
                </MQBox>
            </div>
            <div>
                <MQBox mq="anyHover">
                    any-hover: hover
                </MQBox>
                <MQBox mq="anyHoverNone">
                    any-hover: none
                </MQBox>
            </div>
        </>;
    }
});
